import Ajax from './Ajax.js'

const Area = {
  getAreasPrivateKey: (id) => {
    return Ajax.get(`/areas/${id}/private-key`);
  },
  allowWallet: (walletAddress) => {
    return Ajax.post(`/areas/${walletAddress}/allow-wallet`)
  },
  claim: (id) => {
    return Ajax.post(`/areas/${id}/claim`)
  },
  getClaimable: (id) => {
    return Ajax.get(`/areas/${id}/claim`)
  },
  getBalance: (id) => {
    return Ajax.get(`/areas/${id}/balance`)
  },
  getCheckpoints: (id) => {
    return Ajax.get(`/areas/${id}/checkpoints`)
  },
  withdraw: (id, data) => {
    return Ajax.post(`/areas/${id}/withdraw/${data.walletAddress}`, {amount: data.amount})
  },
  getAreas: (id = null, userId) => {
    let uri = '/areas';
    if (id !== null) {
      uri += '/' + id;
    } else if (userId) {
      uri += `?users_permissions_user.id_eq=${userId}`;
    }
    return Ajax.get(uri);
  },
  getAreaInfo: (id = null) => {
    return Ajax.get(`/areas/${id}/info`);
  },
  // What the trees of a forest are for (Trees = whole ERC-721 trees, Splits = ERC-1155): stock of each (administrators)
  getTreeStock: (id) => {
    return Ajax.get(`/areas/${id}/tree-stock`);
  },
  // Moves `count` free trees of the forest to the stock of `to` ('trees' | 'splits') (administrators)
  moveTrees: (id, to, count) => {
    return Ajax.post(`/areas/${id}/tree-purpose`, { to, count });
  },
  getAreasMap: () => {
    let uri = '/areas/map';
    return Ajax.get(uri);
  },
  getAreasPerimeters: (ids) => {
    return Ajax.post('/areas/perimeters', { ids });
  },

  getAreasDatatables: () => {
    let uri = '/areas-datatables';
    return Ajax.get(uri);
  },
  postAreas: (params) => {
    const payload = params && params.data ? params : { data: params }
    return Ajax.post('/areas', payload)
  },
  putAreas: (params) => {
    const id = params.id
    const data = { ...params }
    delete data.id
    const payload = params && params.data ? params : { data }
    return Ajax.put('/areas/' + id, payload)
  },
  delAreas: (id) => {
    return Ajax.delete('/areas/' + id)
  }
}

export default Area
